import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useEsri } from '../../esriHooks'

import { getView } from '../selectors'

export const useBasemapSwitch = (mapId, position, next) => {
  const [ready, { BasemapToggle }] = useEsri(['esri/widgets/BasemapToggle'])
  const view = useSelector(getView(mapId))

  useEffect(() => {
    if (ready && BasemapToggle && view) {
      const basemapToggle = new BasemapToggle({
        view,
        nextBasemap: next || 'satellite'
      })
      view.ui.add(basemapToggle, position || 'top-left')
    }
  }, [ready, BasemapToggle, view, position, next])

  return null
}
